import React from "react"
import styles from "./joinus.css"

const Joinus = ( { eventBriteModalTriggerElementId,aboutWrapUrl } ) => {

  return (
    <section className="join" id="Joinus">
      
      <div className="joinuswrap">
      <div className="containfix">
        <div className="joinus">
          <div className="jtext">
            JOIN US!
          </div>
          <div className="colcenter"></div>
          <div className="regcol">
            <a className="regop" id={eventBriteModalTriggerElementId} href={aboutWrapUrl}>REGISTER »</a>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default Joinus